export const menuCategories = [
  {
    id: 'antipasti',
    name: {
      de: 'Antipasti',
      en: 'Antipasti'
    },
    description: {
      de: 'Italienische Vorspeisen',
      en: 'Italian starters'
    }
  },
  {
    id: 'pasta',
    name: {
      de: 'Pasta',
      en: 'Pasta'
    },
    description: {
      de: 'Hausgemachte Pasta-Kreationen',
      en: 'Homemade pasta creations'
    }
  },
  {
    id: 'pizza',
    name: {
      de: 'Pizza',
      en: 'Pizza'
    },
    description: {
      de: 'Aus unserem Steinofen',
      en: 'From our stone oven'
    }
  },
  {
    id: 'secondi',
    name: {
      de: 'Hauptgerichte',
      en: 'Main Courses'
    },
    description: {
      de: 'Fleisch- und Fischgerichte',
      en: 'Meat and fish dishes'
    }
  },
  {
    id: 'dolci',
    name: {
      de: 'Desserts',
      en: 'Desserts'
    },
    description: {
      de: 'Süße Verführungen',
      en: 'Sweet temptations'
    }
  },
  {
    id: 'beverages',
    name: {
      de: 'Getränke',
      en: 'Beverages'
    },
    description: {
      de: 'Weine, Softdrinks & mehr',
      en: 'Wines, soft drinks & more'
    }
  }
];

export const menuItems = [
  // Antipasti
  {
    id: 1,
    category: 'antipasti',
    name: {
      de: 'Bruschetta Classica',
      en: 'Classic Bruschetta'
    },
    description: {
      de: 'Geröstetes Ciabatta mit frischen Tomaten, Knoblauch, Basilikum und nativem Olivenöl',
      en: 'Toasted ciabatta with fresh tomatoes, garlic, basil, and extra virgin olive oil'
    },
    price: 8.90,
    image: 'https://images.unsplash.com/photo-1572695157366-5e585ab2b69f?w=400&h=300&fit=crop',
    dietary: ['vegetarian', 'vegan'],
    featured: false
  },
  {
    id: 2,
    category: 'antipasti',
    name: {
      de: 'Carpaccio di Manzo',
      en: 'Beef Carpaccio'
    },
    description: {
      de: 'Hauchdünn geschnittenes Rinderfilet mit Rucola, Parmesan und Trüffelöl',
      en: 'Thinly sliced beef fillet with arugula, parmesan, and truffle oil'
    },
    price: 16.90,
    image: 'https://images.unsplash.com/photo-1588168333986-5078d3ae3976?w=400&h=300&fit=crop',
    dietary: [],
    featured: true
  },
  {
    id: 3,
    category: 'antipasti',
    name: {
      de: 'Burrata con Pomodori',
      en: 'Burrata with Tomatoes'
    },
    description: {
      de: 'Cremige Burrata aus Apulien mit San Marzano Tomaten und Basilikum-Pesto',
      en: 'Creamy Apulian burrata with San Marzano tomatoes and basil pesto'
    },
    price: 14.90,
    image: 'https://images.unsplash.com/photo-1608897013039-887f21d8c804?w=400&h=300&fit=crop',
    dietary: ['vegetarian'],
    featured: true
  },
  {
    id: 4,
    category: 'antipasti',
    name: {
      de: 'Calamari Fritti',
      en: 'Fried Calamari'
    },
    description: {
      de: 'Knusprig frittierte Tintenfischringe mit Aioli und Zitrone',
      en: 'Crispy fried calamari rings with aioli and lemon'
    },
    price: 13.90,
    image: 'https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?w=400&h=300&fit=crop',
    dietary: [],
    featured: false
  },

  // Pasta
  {
    id: 10,
    category: 'pasta',
    name: {
      de: 'Spaghetti Carbonara',
      en: 'Spaghetti Carbonara'
    },
    description: {
      de: 'Klassisch römisch mit Guanciale, Eigelb, Pecorino und schwarzem Pfeffer',
      en: 'Classic Roman style with guanciale, egg yolk, pecorino, and black pepper'
    },
    price: 16.90,
    image: 'https://images.unsplash.com/photo-1612874742237-6526221588e3?w=400&h=300&fit=crop',
    dietary: [],
    featured: true
  },
  {
    id: 11,
    category: 'pasta',
    name: {
      de: 'Tagliatelle al Tartufo',
      en: 'Truffle Tagliatelle'
    },
    description: {
      de: 'Hausgemachte Bandnudeln mit schwarzem Trüffel, Butter und Parmesan',
      en: 'Homemade ribbon pasta with black truffle, butter, and parmesan'
    },
    price: 24.90,
    image: 'https://images.unsplash.com/photo-1556761223-4c4282c73f77?w=400&h=300&fit=crop',
    dietary: ['vegetarian'],
    featured: true
  },
  {
    id: 12,
    category: 'pasta',
    name: {
      de: 'Penne all\'Arrabbiata',
      en: 'Penne Arrabbiata'
    },
    description: {
      de: 'Penne mit feuriger Tomatensauce, Knoblauch und Peperoncino',
      en: 'Penne with fiery tomato sauce, garlic, and peperoncino'
    },
    price: 13.90,
    image: 'https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=400&h=300&fit=crop',
    dietary: ['vegetarian', 'vegan'],
    featured: false
  },
  {
    id: 13,
    category: 'pasta',
    name: {
      de: 'Ravioli di Ricotta e Spinaci',
      en: 'Ricotta & Spinach Ravioli'
    },
    description: {
      de: 'Hausgemachte Ravioli mit Ricotta und Spinat in Salbeibutter',
      en: 'Homemade ravioli with ricotta and spinach in sage butter'
    },
    price: 17.90,
    image: 'https://images.unsplash.com/photo-1587740908075-9e245070dfaa?w=400&h=300&fit=crop',
    dietary: ['vegetarian'],
    featured: false
  },
  {
    id: 14,
    category: 'pasta',
    name: {
      de: 'Linguine alle Vongole',
      en: 'Linguine with Clams'
    },
    description: {
      de: 'Linguine mit frischen Venusmuscheln, Weißwein, Knoblauch und Petersilie',
      en: 'Linguine with fresh clams, white wine, garlic, and parsley'
    },
    price: 19.90,
    image: 'https://images.unsplash.com/photo-1563379926898-05f4575a45d8?w=400&h=300&fit=crop',
    dietary: [],
    featured: false
  },

  // Pizza
  {
    id: 20,
    category: 'pizza',
    name: {
      de: 'Pizza Margherita',
      en: 'Pizza Margherita'
    },
    description: {
      de: 'San Marzano Tomaten, Mozzarella di Bufala, frisches Basilikum',
      en: 'San Marzano tomatoes, buffalo mozzarella, fresh basil'
    },
    price: 13.90,
    image: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=400&h=300&fit=crop',
    dietary: ['vegetarian'],
    featured: false
  },
  {
    id: 21,
    category: 'pizza',
    name: {
      de: 'Pizza Diavola',
      en: 'Pizza Diavola'
    },
    description: {
      de: 'Tomatensauce, Mozzarella, scharfe Salami, Peperoncino',
      en: 'Tomato sauce, mozzarella, spicy salami, peperoncino'
    },
    price: 15.90,
    image: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=400&h=300&fit=crop',
    dietary: [],
    featured: false
  },
  {
    id: 22,
    category: 'pizza',
    name: {
      de: 'Pizza Quattro Formaggi',
      en: 'Four Cheese Pizza'
    },
    description: {
      de: 'Mozzarella, Gorgonzola, Parmesan und Fontina',
      en: 'Mozzarella, gorgonzola, parmesan, and fontina'
    },
    price: 16.90,
    image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400&h=300&fit=crop',
    dietary: ['vegetarian'],
    featured: true
  },
  {
    id: 23,
    category: 'pizza',
    name: {
      de: 'Pizza Prosciutto e Rucola',
      en: 'Prosciutto & Arugula Pizza'
    },
    description: {
      de: 'Tomatensauce, Mozzarella, Parmaschinken, Rucola, Parmesan',
      en: 'Tomato sauce, mozzarella, Parma ham, arugula, parmesan'
    },
    price: 17.90,
    image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&h=300&fit=crop',
    dietary: [],
    featured: false
  },

  // Secondi
  {
    id: 30,
    category: 'secondi',
    name: {
      de: 'Ossobuco alla Milanese',
      en: 'Ossobuco Milanese'
    },
    description: {
      de: 'Geschmorte Kalbshaxe mit Gremolata, dazu Safranrisotto',
      en: 'Braised veal shank with gremolata, served with saffron risotto'
    },
    price: 32.90,
    image: 'https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop',
    dietary: [],
    featured: true
  },
  {
    id: 31,
    category: 'secondi',
    name: {
      de: 'Saltimbocca alla Romana',
      en: 'Saltimbocca Romana'
    },
    description: {
      de: 'Kalbsschnitzel mit Salbei und Parmaschinken in Weißweinsauce',
      en: 'Veal cutlet with sage and Parma ham in white wine sauce'
    },
    price: 26.90,
    image: 'https://images.unsplash.com/photo-1432139555190-58524dae6a55?w=400&h=300&fit=crop',
    dietary: [],
    featured: false
  },
  {
    id: 32,
    category: 'secondi',
    name: {
      de: 'Branzino al Forno',
      en: 'Baked Sea Bass'
    },
    description: {
      de: 'Im Ofen gebackener Wolfsbarsch mit Zitronen, Kapern und Oliven',
      en: 'Oven-baked sea bass with lemons, capers, and olives'
    },
    price: 28.90,
    image: 'https://images.unsplash.com/photo-1519708227418-c8fd9a32b7a2?w=400&h=300&fit=crop',
    dietary: ['glutenFree'],
    featured: false
  },
  {
    id: 33,
    category: 'secondi',
    name: {
      de: 'Tagliata di Manzo',
      en: 'Sliced Beef Tagliata'
    },
    description: {
      de: 'Gegrilltes Rinderfilet auf Rucola mit Parmesan und Balsamico',
      en: 'Grilled beef fillet on arugula with parmesan and balsamic'
    },
    price: 29.90,
    image: 'https://images.unsplash.com/photo-1558030006-450675393462?w=400&h=300&fit=crop',
    dietary: ['glutenFree'],
    featured: false
  },

  // Dolci
  {
    id: 40,
    category: 'dolci',
    name: {
      de: 'Tiramisu',
      en: 'Tiramisu'
    },
    description: {
      de: 'Das italienische Original mit Mascarpone, Espresso und Amaretto',
      en: 'The Italian original with mascarpone, espresso, and amaretto'
    },
    price: 8.90,
    image: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=400&h=300&fit=crop',
    dietary: ['vegetarian'],
    featured: true
  },
  {
    id: 41,
    category: 'dolci',
    name: {
      de: 'Panna Cotta',
      en: 'Panna Cotta'
    },
    description: {
      de: 'Cremige Vanille-Panna Cotta mit Waldbeeren-Coulis',
      en: 'Creamy vanilla panna cotta with forest berry coulis'
    },
    price: 7.90,
    image: 'https://images.unsplash.com/photo-1488477181946-6428a0291777?w=400&h=300&fit=crop',
    dietary: ['vegetarian', 'glutenFree'],
    featured: false
  },
  {
    id: 42,
    category: 'dolci',
    name: {
      de: 'Gelato Misto',
      en: 'Mixed Gelato'
    },
    description: {
      de: 'Drei Kugeln hausgemachtes Eis nach Wahl',
      en: 'Three scoops of homemade ice cream of your choice'
    },
    price: 6.90,
    image: 'https://images.unsplash.com/photo-1501443762994-82bd5dace89a?w=400&h=300&fit=crop',
    dietary: ['vegetarian', 'glutenFree'],
    featured: false
  },
  {
    id: 43,
    category: 'dolci',
    name: {
      de: 'Cannoli Siciliani',
      en: 'Sicilian Cannoli'
    },
    description: {
      de: 'Knusprige Teigröllchen gefüllt mit süßer Ricotta-Creme',
      en: 'Crispy pastry tubes filled with sweet ricotta cream'
    },
    price: 8.50,
    image: 'https://images.unsplash.com/photo-1551024506-0bccd828d307?w=400&h=300&fit=crop',
    dietary: ['vegetarian'],
    featured: false
  },

  // Beverages
  {
    id: 50,
    category: 'beverages',
    name: {
      de: 'Hauswein (0,25l)',
      en: 'House Wine (0.25l)'
    },
    description: {
      de: 'Rot oder Weiß aus der Toskana',
      en: 'Red or white from Tuscany'
    },
    price: 5.90,
    image: 'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=400&h=300&fit=crop',
    dietary: ['vegan', 'glutenFree'],
    featured: false
  },
  {
    id: 51,
    category: 'beverages',
    name: {
      de: 'Aperol Spritz',
      en: 'Aperol Spritz'
    },
    description: {
      de: 'Der italienische Aperitif-Klassiker',
      en: 'The classic Italian aperitif'
    },
    price: 8.50,
    image: 'https://images.unsplash.com/photo-1560512823-829485b8bf24?w=400&h=300&fit=crop',
    dietary: ['vegan', 'glutenFree'],
    featured: false
  },
  {
    id: 52,
    category: 'beverages',
    name: {
      de: 'Espresso',
      en: 'Espresso'
    },
    description: {
      de: 'Frisch gebrühter italienischer Espresso',
      en: 'Freshly brewed Italian espresso'
    },
    price: 2.90,
    image: 'https://images.unsplash.com/photo-1510591509098-f4fdc6d0ff04?w=400&h=300&fit=crop',
    dietary: ['vegan', 'glutenFree'],
    featured: false
  },
  {
    id: 53,
    category: 'beverages',
    name: {
      de: 'San Pellegrino (0,75l)',
      en: 'San Pellegrino (0.75l)'
    },
    description: {
      de: 'Italienisches Mineralwasser, prickelnd',
      en: 'Italian mineral water, sparkling'
    },
    price: 5.50,
    image: 'https://images.unsplash.com/photo-1523362628745-0c100150b504?w=400&h=300&fit=crop',
    dietary: ['vegan', 'glutenFree'],
    featured: false
  }
];

export const getFeaturedItems = () => menuItems.filter(item => item.featured);

export const getItemsByCategory = (categoryId) =>
  menuItems.filter(item => item.category === categoryId);

export const filterByDietary = (items, filters) => {
  if (!filters || filters.length === 0) return items;
  return items.filter(item =>
    filters.every(filter => item.dietary.includes(filter))
  );
};
